<script setup lang="ts">
import DisruptionProductAvailability from "@/disruption-logistics/views/DisruptionProductAvailability.vue";
import {computed, ref, watch} from "vue";
import {AutoCompleteSearchbar} from "@/auto-complete-searchbar/components/searchbar";
import {
    AUTO_COMPLETE_REQUEST_TYPE,
    ProductSearchQueryParams,
    SearchBarAutoCompleteItem
} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import debounce from "lodash.debounce";
import SearchBarAutoCompleteService from "@/auto-complete-searchbar/services/SearchBarAutoCompleteService";
import DisruptionLogisticsRequestService from "@/disruption-logistics/services/DisruptionLogisticsRequestService";
import RequestState from "@/disruption-logistics/components/request-state/RequestState.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {useDisruptionLogisticsRequestStore} from "@/stores/disruptionLogisticsRequest.store";
import {storeToRefs} from "pinia";

const loading = ref<boolean>(false);
const items = ref<SearchBarAutoCompleteItem[]>([]);
const searchParams = ref<ProductSearchQueryParams>({});
const requestToken = ref<string>();
const {subscribed, remainingRequests} = storeToRefs(useDisruptionLogisticsRequestStore());

const canRequest = computed(() => {
    return subscribed.value || remainingRequests.value > 0;
});

/**
 * Update search item.
 */
const updateSearchItem = debounce((items: SearchBarAutoCompleteItem[]) => {
    if (canRequest.value) {
        searchParams.value = SearchBarAutoCompleteService.transformToQueryParams(items);

        DisruptionLogisticsRequestService.pharmaMLRequestToken()
            .then(token => {
                requestToken.value = token;
            });
    }
}, 500);


watch(items, updateSearchItem);
</script>

<template>
  <BaseFlexSpinner v-if="loading" />
  <div v-else class="p-4">
    <div class="bg-white p-2 mb-4 rounded-md flex flex-col gap-2">
      <AutoCompleteSearchbar
        v-model:selected-items="items"
        :request-types="[
          AUTO_COMPLETE_REQUEST_TYPE.PRODUCT,
          AUTO_COMPLETE_REQUEST_TYPE.LABORATORY,
          AUTO_COMPLETE_REQUEST_TYPE.RANGE,
          AUTO_COMPLETE_REQUEST_TYPE.DCI,
          AUTO_COMPLETE_REQUEST_TYPE.GENERIC,
          AUTO_COMPLETE_REQUEST_TYPE.VIDAL_LEVEL3,
        ]"
      />
      <RequestState class="px-2" />
    </div>
    <disruption-product-availability
      v-if="requestToken"
      display-product
      :filters="searchParams"
      :request-token="requestToken"
    />
  </div>
</template>
